import {render} from '@wordpress/element';
import {shetradesBlockView} from './includes';


/**
 * [View description]
 * @param {[type]} props [description]
 */
export default function View(props) {
    return shetradesBlockView(props);
}

render(<View attributes = {args.attributes} editor = {args.editor} terms = {args.terms} />, document.getElementById(args.id));